// 사건 상세 라우트 분기 — 선정 전(is_assigned=false) / 선정 후(true).
//
// 옛 데이터는 is_assigned 미설정인데, 09 §1.1 정책상 default true (감정 단계로 해석).
// 따라서 명시적으로 false 일 때만 예상감정료 상세로 보냄.

interface AppraisalLike {
  id: string;
  is_assigned?: boolean;
}

export function getAppraisalDetailPath(a: AppraisalLike): string {
  return a.is_assigned === false ? `/expected-fees/${a.id}` : `/contents/${a.id}`;
}
